export default "__VITE_ASSET__BPuCi_qu__"